import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import LargePopper from '../assets/LargePopper';
import CircularProgress from '@mui/material/CircularProgress';

export const DataGridMultiSelectFilter: React.ComponentType<{
  props: any;
  schema: any;
  columnData?: any;
  onChange: (value: any) => void;
}> = ({ props, onChange, columnData, schema }) => {
  const [filterOptions, setFilterOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (columnData) {
      setLoading(true);
      const flattenedData = columnData.flatMap((array: any) => array);

      const uniqueOptions = flattenedData
        .filter(
          (value: any, index: any, self: any) =>{
            return value?.id &&
              value?.name &&
              index === self.findIndex((v: any) => v?.id === value?.id);

          }
        )
        .map((value: any) => ({ id: value.id, name: value.name }));
      setFilterOptions(uniqueOptions);
      setLoading(false);
    }
  }, [columnData]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleOnChange = (event: any, value: any) => onChange(value);

  return (
    <Autocomplete
      open={open}
      onOpen={handleOpen}
      onClose={handleClose}
      PopperComponent={LargePopper}
      fullWidth={true}
      size="small"
      options={filterOptions}
      getOptionLabel={(option: any) => option.name}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
      onChange={(event, newValue) => {
        handleOnChange(event, newValue);
      }}
      //onInputChange={debouncedOnChange}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            size="small"
            InputLabelProps={{
              style: {
                fontSize: 13,
                paddingTop: 2,
              },
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        );
      }}
    />
  );
};
